<!-- 
View for displaying the presentation during a live session.
-->
<template>
	<EmbedProvider>
		<SwiperPresentation
			v-bind="$attrs"
			@slidechange="onSlideChange"
			:initial-slide-index="initialSlideIndex"
		/>
	</EmbedProvider>
</template>

<script setup lang="ts">
import SwiperPresentation from '@/components/presentation/SwiperPresentation.vue'
import { useSessionAnalytics } from '@/mixins/sessionAnalytics'
import { useSessionStore } from '@/stores/session'
import EmbedProvider from '@/views/Session/EmbedProvider.vue'
import { computed } from 'vue'

defineOptions({ inheritAttrs: false })

const { updateSlideAnalytics } = useSessionAnalytics()
const session = useSessionStore()

const initialSlideIndex = computed(
	() => session.activeSession?.currentSlideIndex
)

async function onSlideChange(newIndex: number, previousIndex: number) {
	if (session.activeSession) {
		await updateSlideAnalytics(previousIndex)
		session.activeSession.currentSlideIndex = newIndex
	}
}
</script>
